module.exports = __webpack_public_path__ + "img/img_default_shop_02.b4389368.png";